export default __webpack_public_path__ + "static/media/sumHR-logo.6ebd3414.svg";